import React, { useCallback, useContext, useEffect, useState } from 'react'
import { View, ScrollView, StyleSheet, Text } from 'react-native'
import { Sidebar } from '../components/sections/Sidebar'
import { TopBar } from '../components/sections/TopBar'
import { getStyleSheet } from '../assets/theme/styles'
import { ProjectService } from '../services/ProjectService'
import TabNative from '../components/common/Tab'
import Status from '../components/common/ProjectsTabs/Status'
import Settings from '../components/common/ProjectsTabs/Settings'
import { IProject } from '../interfaces/project.interface'
import { GroupService } from '../services/GroupService'
import { ThemeContext } from '../assets/theme/ThemeProvider'
import { ClientService } from '../services/ClientService'
import GroupedRecordMenu from '../components/common/GroupedRecordMenu/GroupedRecordMenu'
import { StatusProject } from '../models'
import { useToast } from 'react-native-toast-notifications'
import { LoadingSpinner } from '../components/common/LoadingSpinner'
import { useFocusEffect } from '@react-navigation/native'

const options = [
    // { name: 'STATUS', value: 'status' },
    { name: 'SETTINGS', value: 'settings' },
]

const ProjectDetails = ({ ...props }) => {
    const current = 'ProjectDetails'
    const styles = getStyleSheet()
    const [project, setProject] = useState<IProject | null>(null)
    const { projectId } = props.route.params
    const { userSub } = useContext<any>(ThemeContext)
    const [valueSelectButton, setValueSelectButton] = useState('')
    const [allClients, setAllClients] = useState(null)
    const [allGroups, setAllGroups] = useState([])
    const [projectName, setProjectName] = useState('')
    const toast = useToast()

    const onChangeSelectButton = (value: string | number) => {
        props.navigation.setParams({ edit: value })
        setValueSelectButton(value as string)
        if (value === 'settings') getProjectDetails()
    }

    const getProjectDetails = async () => {
        const project = await ProjectService().getProjectById(projectId)
        if (project) setProject(project)
    }

    const onUpdateProject = async (id: any, newObject: any = null) => {
        if (id && project) {
            newObject = {
                id: project.id,
                status: StatusProject.ARCHIVED,
                _version: project._version,
            }
        }

        ProjectService()
            .updateProjectById(newObject)
            .then(() => {
                toast.show('Project was updated successfully', {
                    type: 'success',
                })
            })
            .catch(() => {})
    }

    const actions = [
        {
            action: () => onUpdateProject(project?.id),
            label: 'Archived',
            icon: 'archive',
        },
    ]

    const getClients = () => {
        ClientService()
            .getClientsDropDown(userSub)
            .then(data => {
                setAllClients(data)
            })
    }

    const getGroups = () => {
        GroupService()
            .getGroupsDropdown(userSub)
            .then(data => {
                setAllGroups(data)
            })
    }

    useFocusEffect(
        useCallback(() => {
            getProjectDetails()
            return () => setProject(null)
        }, [projectId])
    )

    useFocusEffect(
        useCallback(() => {
            getGroups()
            getClients()
        }, [])
    )

    useFocusEffect(
        useCallback(() => {
            if (props.route.params?.edit) setValueSelectButton(props.route.params.edit)
            else setValueSelectButton('settings')
        }, [props.route.params?.edit])
    )

    return (
        <View style={localStyles.container}>
            <Sidebar children={{ active: current }} />
            <View style={localStyles.subcontainer}>
                <ScrollView
                    contentContainerStyle={!project ? { flexGrow: 1, overflow: 'hidden' } : {}}
                    style={[styles.styleBackground.container]}
                    stickyHeaderIndices={[0]}
                >
                    <TopBar children={{ active: current, initial: 0 }} />
                    {!project ? (
                        <LoadingSpinner loadVisible={true} />
                    ) : (
                        <View style={localStyles.workArea}>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 20 }}>
                                <Text style={{ fontSize: 18, fontWeight: '600', color: styles.text }}>
                                    {projectName}
                                </Text>
                                <GroupedRecordMenu identificator={project.id} items={actions} />
                            </View>
                            <TabNative
                                containerStyle={{ height: 42, alignSelf: 'flex-start' }}
                                buttonStyle={{ height: 42 }}
                                value={valueSelectButton}
                                onChange={onChangeSelectButton}
                                options={options}
                            />
                            <View style={{ backgroundColor: styles.formContainerBackground, padding: 20 }}>
                                {valueSelectButton === 'status' && <Status project={project} />}
                                {valueSelectButton === 'settings' && (
                                    <Settings
                                        project={project}
                                        setProjectName={setProjectName}
                                        clients={allClients}
                                        groups={allGroups}
                                    />
                                )}
                            </View>
                        </View>
                    )}
                </ScrollView>
            </View>
        </View>
    )
}

const localStyles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
    },
    subcontainer: {
        flex: 1,
        flexDirection: 'column',
        backgroundColor: '#fff',
    },
    workArea: {
        width: 'auto',
        marginLeft: 29,
        marginRight: 29,
        marginTop: 29,
    },
    searchContainer: {
        zIndex: 5010,
        flexDirection: 'row',
        marginBottom: 12,
        height: 41,
    },
    textInputSearch: {
        paddingLeft: 10,
        width: 295,
        height: 40,
        borderColor: 'gray',
        borderRadius: 6,
        fontStyle: 'italic',
    },
    iconSearch: {
        width: 22,
        height: 22,
        position: 'absolute',
        marginTop: 10,
        right: 10,
    },
})

export default ProjectDetails
